<template>
  <div>
    <div class="section" v-if="screenWidth > 600">
      <div class="swiper mySwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="section section1">
              <div class="main_content">
                <div class="title first_title">
                  <div class="div1 white">公司介绍</div>
                  <div class="div2 white_gradient">COMPANY INTRODUCTION</div>
                  <span class="line"></span>
                </div>
                <div
                  class="section1_content white"
                  :class="{
                    animate__animated: true,
                    hide: curPage !== 0,
                    animate__zoomIn: curPage === 0,
                  }"
                >
                  <p>
                    辰鳗科技集团，全球优秀的综合能源服务商，自2020年创立以来，以能源科技研发创新为驱动，致力于服务全球工商业电力用户。以集团总部成都——云枢大脑中心、华东总部杭州——AI算法中心，为两大核心动力枢纽，为中国大陆工商电力用户提供全生命周期能源管理服务。同时，集团充分发挥南京、天津、长沙、北京、广州、拉萨、杭州等控股公司的区域优势与资源效能，织就一张覆盖全国，运转高效的业务服务网络，实现能源管理业务在中国范围内的客户服务与运维保障。
                  </p>
                  <p>
                    截至2025年底，业务版图已成功延伸至全球6个国家、243座城市，累计服务工商业电力用户数量25.77万户。下一步，集团将依托“产品+AI”服务能力，在2030年全国电力统一市场全面建成前，完成国内所有省份的电力市场规则深度学习和匹配，致力于提升云枢平台的通用性与针对性，在预测和交易相关算法的mAP准确率达到95%以上；推动新能源资产和负荷侧资源的代运营体量实现指数级增长；积极布局国际市场，针对国际上存在开放电力市场的国家，开展针对性的训练与落地应用工作。
                  </p>
                  <p>
                    秉持“每一度，我们在服务”的企业使命，辰鳗科技集团深度聚焦综合能源服务领域。依托集团旗下自主研发的小鳗鱼云枢星能智控平台，通过人工智能、物联网、多源异构能源算法、双碳能源管控等技术，从源网荷储碳投建运一体化、新能源光储资产代运营和全国电力市场交易服务三大核心板块精准发力，积极探索公建、工业、商业等多领域绿色转型的创新路径与全新方向，为行业绿色发展注入源源不断的动力。
                  </p>

                  <p>
                    在源网荷储碳投建运一体化方面，涵盖零碳园区、工厂、区域微电网、虚拟电厂、分布式光伏、储能投建、节能技术服务、能源AI平台等多元业务实现区域绿色转型，参与园区能源资产长期运营；在新能源光储资产代运营板块，涉及电力市场运营业务、绿电交易、绿能替代、需求侧响应等关键服务，最大化实现新能源资产的价值；在全国电力市场交易服务领域，提供电力市场AI现货预测、出清、电能量交易全生命周期服务、辅助服务配套等技术。
                  </p>
                  <p>
                    展望未来，辰鳗科技集团将以全球化为翼，以高质量发展为基，不断深化技术革新，积极拓宽服务领域，携手全球各地的合作伙伴，共同推动全球能源结构性转型与绿色低碳发展，为构建一个更加智慧、高效、可持续的零碳能源生态贡献辰鳗力量！
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="section section2">
              <div class="main_content">
                <div class="title">
                  <div class="div1 black">发展历程</div>
                  <div class="div2 black_gradient">DEVELOPMENT HISTORY</div>
                  <span class="line"></span>
                </div>
                <div class="section2_content white"></div>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="section section3">
              <div class="main_content">
                <div class="title">
                  <div class="div1 white">知识产权</div>
                  <div class="div2 white_gradient">INTELLECTUAL PROPERTY</div>
                  <span class="line"></span>
                </div>
                <div class="main_top">
                  <div
                    class="carousel_title"
                    :class="{ carousel_active: type == 5 }"
                    @click="handleClick(5)"
                  >
                    高新技术企业证书
                  </div>
                  <div
                    class="carousel_title"
                    :class="{ carousel_active: type == 1 }"
                    @click="handleClick(1)"
                  >
                    产品专利证书
                  </div>
                  <div
                    class="carousel_title"
                    :class="{ carousel_active: type == 2 }"
                    @click="handleClick(2)"
                  >
                    软件著作权
                  </div>
                  <div
                    class="carousel_title"
                    :class="{ carousel_active: type == 3 }"
                    @click="handleClick(3)"
                  >
                    产品型号证书
                  </div>
                  <div
                    class="carousel_title"
                    :class="{ carousel_active: type == 4 }"
                    @click="handleClick(4)"
                  >
                    质量管理证书
                  </div>
                </div>
                <div
                  :autoplay="false"
                  arrow="never"
                  indicator-position="none"
                  class="carousel_content space_around"
                  v-if="type == 5"
                >
                  <div style="height: 464px; height: 328px">
                    <div class="content_imgWrap1">
                      <img :src="gximgpage" style="height: 328px; width: 464px" />
                    </div>
                    <div>
                      <p class="content_title">{{ "高新技术企业证书" }}</p>
                    </div>
                  </div>
                </div>
                <div
                  :autoplay="false"
                  arrow="never"
                  indicator-position="none"
                  class="carousel_content"
                  v-else-if="type == 1"
                >
                  <div
                    v-for="(item, index) in cpzlData"
                    :key="index"
                    class="content_item1"
                  >
                    <div class="content_imgWrap">
                      <img :src="item.url" alt="" class="content_img" />
                    </div>
                    <div>
                      <p class="content_title">{{ item.desc }}</p>
                    </div>
                  </div>
                </div>
                <div
                  :autoplay="false"
                  arrow="never"
                  indicator-position="none"
                  class="carousel_content space_around"
                  v-else-if="type == 4"
                >
                  <div
                    v-for="(item, index) in zlglData"
                    :key="index"
                    class="content_item"
                  >
                    <div class="content_imgWrap">
                      <img :src="item.url" alt="" class="content_img" />
                    </div>
                    <div>
                      <p class="content_title">{{ item.desc }}</p>
                    </div>
                  </div>
                </div>
                <div class="theSwiper" v-else>
                  <div class="leftArrow arrow">
                    <i class="el-icon-back white" @click="prevBtn"></i>
                  </div>
                  <swiper
                    ref="mySwiper"
                    style="position: relative"
                    :options="swiperOption"
                  >
                    <swiper-slide
                      v-for="(item, index) in swiperArr"
                      :key="index"
                      class="swiper_wrap"
                    >
                      <div class="content_imgWrap">
                        <img :src="item.url" alt="" class="content_img" />
                      </div>
                      <div>
                        <p class="content_title">{{ item.desc }}</p>
                      </div>
                    </swiper-slide>
                  </swiper>
                  <div class="rightArrow arrow">
                    <i class="el-icon-right white" @click="nextBtn"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="section section4">
              <div class="main_content">
                <div class="title">
                  <div class="div1 black">合作伙伴</div>
                  <div class="div2 black_gradient">PARTNERS</div>
                  <span class="line"></span>
                </div>
              </div>
              <div class="section4_content"></div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="section section5">
              <div class="main_content">
                <div class="title">
                  <div class="div1 white">联系我们</div>
                  <div class="div2 white_gradient">CONTACT US</div>
                  <span class="line"></span>
                </div>
                <div class="section5_content">
                  <img src="../../assets/map.png" alt="" class="map_img" />
                  <div class="address_bottom">
                    <ul class="left">
                      <li>
                        <p>客服电话：</p>
                        <p>028-86533354</p>
                      </li>
                      <li>
                        <p>客服时间：</p>
                        <p>09:00-18:00</p>
                      </li>
                      <li>
                        <p>商业合作邮箱：</p>
                        <p>xiaomanguanjia@smalleel.com</p>
                      </li>
                    </ul>
                    <ul class="right">
                      <li>
                        <p>公司地址：</p>
                        <p>四川省成都市双流区电子科大科技园B12栋四单元4F-6F</p>
                      </li>
                      <li class="qrcode_wrap">
                        <div class="qrcode" style="margin-right: 110px">
                          <img src="../../assets/qrcode1.png" alt="" />
                          <p>小鳗科技</p>
                        </div>
                        <div class="qrcode">
                          <img src="../../assets/qrcode2.png" alt="" />
                          <p>小鳗管家</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-scrollbar"></div>
      </div>
    </div>
    <div class="phonePage" v-else>
      <phoneCloseCM />
    </div>
  </div>
</template>
<script>
import cpzl1 from "@/assets/aboutUs/cpzl/1.jpg";
import cpzl2 from "@/assets/aboutUs/cpzl/2.jpg";

import cpxh1 from "@/assets/aboutUs/cpxh/1.jpg";
import cpxh2 from "@/assets/aboutUs/cpxh/2.jpg";
import cpxh3 from "@/assets/aboutUs/cpxh/3.jpg";
import cpxh4 from "@/assets/aboutUs/cpxh/4.jpg";

import zlgl1 from "@/assets/aboutUs/zlgl/1.jpg";
import zlgl2 from "@/assets/aboutUs/zlgl/2.jpg";
import zlgl3 from "@/assets/aboutUs/zlgl/3.jpg";

import rjzz124 from "@/assets/aboutUs/rjzz/124.jpg";
import rjzz134 from "@/assets/aboutUs/rjzz/134.jpg";
import rjzz197 from "@/assets/aboutUs/rjzz/197.jpg";
import rjzz319 from "@/assets/aboutUs/rjzz/319.jpg";
import rjzz321 from "@/assets/aboutUs/rjzz/321.jpg";
import rjzz322 from "@/assets/aboutUs/rjzz/322.jpg";
import rjzz587 from "@/assets/aboutUs/rjzz/587.jpg";
import rjzz590 from "@/assets/aboutUs/rjzz/590.jpg";
import rjzz591 from "@/assets/aboutUs/rjzz/591.jpg";
import rjzz759 from "@/assets/aboutUs/rjzz/759.jpg";
import rjzz807 from "@/assets/aboutUs/rjzz/807.jpg";
import rjzz855 from "@/assets/aboutUs/rjzz/855.jpg";
import rjzz884 from "@/assets/aboutUs/rjzz/884.jpg";
import rjzz891 from "@/assets/aboutUs/rjzz/891.jpg";
import rjzz892 from "@/assets/aboutUs/rjzz/892.jpg";

import gximg from "@/assets/service/gx.png";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

import phoneCloseCM from "./phone/phoneCloseCM.vue";
import Swiper from "swiper";
import { EventBus } from "@/untils/eventBus";

export default {
  name: "aboutUs",
  components: {
    // 注册组件
    phoneCloseCM,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      gximgpage: gximg,
      screenWidth: document.body.clientWidth,
      swiperOption: {
        slidesPerView: 3, //一行显示3个
        speed: 1000, //滑动速度
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        loop: true,
        autoplay: {
          delay: 1000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        loopAdditionalSlides: 1,
        on: {
          slideChangeTransitionEnd: function () {
            //获取当前下标，切换结束时，告诉我现在是第几个slide
          },
        },
      },
      type: 5,
      swiperArr: [],
      cpzlData: [
        {
          url: cpzl2,
          desc: "一种带有能耗异常告警的智能电表 CN217587346U 实用新型",
        },
        {
          url: cpzl1,
          desc: "一种带有防窃电功能的智能电表 CN217587359U 实用新型",
        },
      ],
      cpxhData: [
        { url: cpxh1, desc: "单相电子式电能表(导轨),DDSU6610" },
        { url: cpxh2, desc: "单相电子式预付费电能表,DDSY6610" },
        { url: cpxh3, desc: "三相四线电子式电能表(导轨),DTSU6610" },
        { url: cpxh4, desc: "三相四线电子式预付费电能表,DTSY6610" },
      ],
      zlglData: [
        { url: zlgl1, desc: "质量管理体系认证证书 41922Q00187-04R0S" },
        {
          url: zlgl2,
          desc: "环境管理体系认证证书 41922E00115-04R0S",
        },
        {
          url: zlgl3,
          desc: "职业健康安全管理体系认证证书 41922S00115-04R0S",
        },
      ],
      rjzzData: [
        {
          url: rjzz124,
          desc: "小鳗智能设备实时能耗监测管控平台 2022SR0667124",
        },
        { url: rjzz134, desc: "小鳗物业系统 2022SR0529134" },
        { url: rjzz197, desc: "小鳗商户系统  2022SR0525197" },
        { url: rjzz319, desc: "小鳗平台管理系统 2022SR0530319" },
        { url: rjzz321, desc: "小鳗管家收费智能云平台 2022SR0530321" },
        { url: rjzz322, desc: "小鳗企业管理系统 2022SR0530322" },
        {
          url: rjzz587,
          desc: "小鳗智能设备终端信息交互控制管理系统 2022SR0654587",
        },
        { url: rjzz590, desc: "小鳗智能设备故障预警管理软件 2022SR0654590" },
        {
          url: rjzz591,
          desc: "小鳗智能设备能耗数据在线监测预警分析系统 2022SR0654591",
        },
        { url: rjzz759, desc: "小鳗智能设备定时控制系统 2022SR0569759" },
        {
          url: rjzz807,
          desc: "小鳗智能设备远程物联信息化管理软件 2022SR0665807",
        },
        { url: rjzz855, desc: "小鳗分润系统 2022SR0569855" },
        { url: rjzz884, desc: "小鳗智能设备数据监控采集系统 2022SR0557884" },
        { url: rjzz891, desc: "小鳗费用管理系统 2022SR0569891" },
        { url: rjzz892, desc: "小鳗开放平台系统 2022SR0569892" },
      ],
      curIndex: 0,
      timer: 1000,
      AutoSwiper: null,
      leftDown: false,
      curPage: 0,
      swiperPage: "",
    };
  },
  watch: {
    screenWidth(newValue) {
      if (!this.timer) {
        this.screenWidth = newValue;
        this.timer = true;
        setTimeout(() => {
          this.timer = false;
        }, 400);
      }
    },
  },
  computed: {
    currentItem() {
      return this.swiperArr[this.curIndex];
    },
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {
    this.initSwiper();
    if (this.$route.params.index) {
      this.swiperPage.slideTo(5, 1000, false);
      EventBus.$emit("index", 4);
    }
  },
  methods: {
    initSwiper() {
      let that = this;
      this.swiperPage = new Swiper(".mySwiper", {
        direction: "vertical",
        effect: "fade",
        slidesPerView: 1,
        observeParents: true,
        initialSlide: 0,
        spaceBetween: 30,
        mousewheel: {
          thresholdTime: 2000,
          thresholdDelta: 120,
        },
        forceToAxis: true,
        scrollbar: {
          el: ".swiper-scrollbar",
        },
        preventClicks: false,
        preventClicksPropagation: false,
        on: {
          slideChangeTransitionEnd() {
            that.curPage = this.activeIndex;
          },
        },
      });
    },
    prevBtn() {
      this.swiper.slidePrev();
    },
    nextBtn() {
      this.swiper.slideNext();
    },
    swiper_enter() {
      this.swiper.autoplay.stop();
    },

    handleClick(type) {
      this.type = type;
      if (type == 2) {
        this.swiperArr = this.rjzzData;
      } else if (type == 3) {
        this.swiperArr = this.cpxhData;
      }
      this.curIndex = 0;
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/style/about.scss";
.section1 {
  background: url("https://file.smalleel.com/2023/08/28/1693187176SaCCw.png") no-repeat;
  background-position: center;
  background-size: cover;
}
.section2 {
  background: url("../../assets/about_bg2.png") no-repeat;
  background-position: center;
  background-size: 100% 100%;
  /* object-fit: cover; */
  /* flex: 1; */
  position: relative;
}
.section3 {
  background: url("../../assets/about_bg3.png") no-repeat;
  background-position: center;
  background-size: cover;
}
.section4 {
  background: url("../../assets/about_bg4.png") no-repeat;
  background-position: center;
  background-size: cover;
}
.section5 {
  background: url("../../assets/about_bg3.png") no-repeat;
  background-position: center;
  background-size: cover;
}

.banner1 {
  padding-top: 236px;
  img {
    width: 160px;
    height: 64px;
  }
  p {
    font-size: 40px;
    font-family: "PangMenZhengDao";
    font-weight: 400;
    color: #ffffff;
    margin-top: 60px;
  }
}
.title {
  text-align: left;
  padding-top: 96px;
  display: flex;
  align-items: baseline;
  .div1 {
    font-size: 60px;
    font-family: "PangMenZhengDao";
    font-weight: 400;
    letter-spacing: 6px;
  }
  .div2 {
    font-size: 24px;
    font-family: "PangMenZhengDao";
    font-weight: 400;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-left: 24px;
  }
  .line {
    display: block;
    width: 5px;
    height: 16px;
    background: #3170ff;
    margin-left: 10px;
  }
}

.white_gradient {
  background-image: linear-gradient(60deg, #fff, #34383c);
  background-clip: text;
}
.black_gradient {
  background: linear-gradient(60deg, #34383b, #fff);
  background-clip: text;
}
.section1_content {
  width: 720px;
  text-align: left;
  margin-top: 76px;
  p {
    text-indent: 28px;
    font-size: 14px;
    font-family: "Regular";
    font-weight: 400;
    color: #ffffff;
    line-height: 24px;
  }
  p:not(:last-child) {
    margin-bottom: 20px;
  }
}
.section2_content {
  display: flex;
  height: 100%;
  .about_img {
    width: 360px;
    height: 362px;
    margin-top: 96px;
  }
}
.section3_content {
  display: flex;
  margin-top: 80px;

  img {
    width: 480px;
    height: 500px;
  }
  .right_box {
    width: 100%;
    height: 500px;
    background: linear-gradient(90deg, #3170ff, #e4ecf8);
    /* background: linear-gradient(to right, #3170ff, #E4ECF8); */
  }
}

.section4_content {
  background: url("../../assets/about_logo.png") center center no-repeat;
  background-size: 100% 100%;
  width: 1200px;
  height: 554px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  margin-top: 67px;
}
.item_wrap {
  position: relative;
  text-align: left;
  .item {
    display: flex;
    height: 110px;
    width: 500px;
    background: #3b80ff;
    margin-top: 55px;
    padding-left: 70px;
    flex-direction: column;
    box-sizing: border-box;
  }
  .icon {
    width: 80px;
    height: 80px;
    position: absolute;
    left: -40px;
    top: 15px;
  }
  .h1 {
    font-size: 18px;
    font-family: "Medium";
    font-weight: 500;
    color: #fdfeff;
    line-height: 30px;
    margin-top: 30px;
  }
  .h2 {
    font-size: 14px;
    font-family: "Regular";
    font-weight: 400;
    color: #fdfeff;
    line-height: 20px;
  }
}

.address_bottom {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
  .left {
    text-align: left;
    li:not(:last-child) {
      margin-bottom: 38px;
    }
    p:first-child {
      font-size: 16px;
      font-family: "Regular";
      font-weight: 400;
      color: #ffffff;
      margin-bottom: 18px;
    }
    p:last-child {
      font-size: 18px;
      font-family: "Regular";
      font-weight: 400;
      color: #4a81ff;
    }
  }
  .right {
    text-align: left;
    li:not(:last-child) {
      margin-bottom: 38px;
    }
    p:first-child {
      font-size: 16px;
      font-family: "Regular";
      font-weight: 400;
      color: #ffffff;
      margin-bottom: 18px;
    }
    p:last-child {
      font-size: 18px;
      font-family: "Regular";
      font-weight: 400;
      color: #4a81ff;
    }
  }
}

.year {
  font-size: 24px;
  font-family: "PangMenZhengDao";
  font-weight: 400;
  color: #447dff;
  line-height: 26px;
  padding-top: 24px;
  margin-left: 24px;
}
.month {
  color: #447dff;
  margin-right: 20px;
  font-size: 14px;
  font-family: "Medium";
  font-weight: 500;
  color: #447dff;
  line-height: 26px;
  margin-left: 24px;
}
.desc {
  color: #6d7072;
  font-size: 14px;
  font-family: "Regular";
  font-weight: 400;
  color: #34383b;
}
.ln26 {
  line-height: 26px;
}
.ln20 {
  line-height: 20px;
}
.process1 {
  width: 326px;
  height: 188px;
  background: #fcfdff;
  box-shadow: 0px 4px 10px 0px rgba(238, 244, 247, 0.3);
  border-radius: 8px;
  text-align: left;
  box-sizing: border-box;
  position: absolute;
  top: 200px;
  right: 490px;
}
.process2 {
  width: 344px;
  height: 248px;
  background: #fcfdff;
  box-shadow: 0px 4px 10px 0px rgba(238, 244, 247, 0.3);
  border-radius: 8px;
  text-align: left;
  box-sizing: border-box;
  position: absolute;
  bottom: 158px;
  right: 250px;
}
.process3 {
  width: 358px;
  height: 160px;
  background: #fcfdff;
  box-shadow: 0px 4px 10px 0px rgba(238, 244, 247, 0.3);
  border-radius: 8px;
  text-align: left;
  box-sizing: border-box;
  position: absolute;
  bottom: 350px;
  right: 830px;
}
.process4 {
  width: 270px;
  height: 98px;
  background: #fcfdff;
  box-shadow: 0px 4px 10px 0px rgba(238, 244, 247, 0.3);
  border-radius: 8px;
  text-align: left;
  box-sizing: border-box;
  position: absolute;
  bottom: 120px;
  right: 650px;
}
/* .process_wrap {
  background: #967;
  height: 100%;
} */
.map_img {
  width: 1200px;
  height: 300px;
  margin-top: 65px;
}
.qrcode_wrap {
  display: flex;
  text-align: center;
  img {
    width: 100px;
    height: 100px;
  }
  p {
    font-size: 16px;
    font-family: "Regular";
    font-weight: 400;
    color: #3170ff;
    margin-top: 20px;
  }
}

.main_top {
  display: flex;
  justify-content: flex-end;
  margin-top: 60px;
}
.carousel_title {
  width: 180px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: #262a2d;
  /* margin: 0 10px; */
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  /* position: absolute; */
}
.carousel_title:not(:last-child) {
  margin-right: 10px;
}
.carousel_active {
  background: url("../../assets/aboutUs/item_bg.png") no-repeat;
  background-position: center;
  background-size: cover;
}

.carousel_content {
  display: flex;
  /* width: 100%; */
  width: 90%;
  margin: auto;
  /* justify-content: center; */
  margin-top: 60px;
}
.content_item1 {
  margin: 0 10%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.content_item {
  width: 274px;
  display: flex;
  flex-direction: column;
  /* background: pink; */
  /* height: 460px; */
}
.content_title {
  font-size: 14px;
  font-family: "Regular";
  font-weight: 400;
  color: #fdfeff;
  line-height: 20px;
  margin-top: 40px;
  /* width: 220px; */
}
.content_desc {
  font-size: 14px;
  font-family: "Regular";
  font-weight: 400;
  color: #ffffff;
  line-height: 22px;
  margin-top: 30px;
  text-indent: 28px;
  margin-left: 60px;
  margin-right: 60px;
}
.content_imgWrap1 {
  height: 411px;
  /* width: 85%; */
  width: 540px;
  background: rgba(52, 56, 59, 0.4);
  box-shadow: 0px 4px 20px 0px rgba(25, 27, 29, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}
.content_imgWrap {
  width: 274px;
  /* width: 85%; */
  height: 360px;
  background: rgba(52, 56, 59, 0.4);
  box-shadow: 0px 4px 20px 0px rgba(25, 27, 29, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}
.content_img {
  width: 212px;
  height: 300px;
}

/deep/ .el-carousel__item {
  position: relative !important;
}
/deep/ .el-carousel__container {
  display: flex;
  justify-content: space-between;
  width: 1200px !important;
  height: 500px !important;
}
.swiper_item {
  display: flex;
  height: 400px;
}

.theSwiper {
  display: flex;
  align-items: center;
  margin-top: 60px;
  .carousel {
    overflow: hidden;
    width: 100%;
    height: 560px;
    /* background: #697; */
  }
  .arrow {
    width: 40px;
    height: 50px;
    background: #232629;
    line-height: 50px;
    text-align: center;
  }
  .carousel_item {
    display: flex;
  }
  .carousel_wrapper {
    transition-property: left;
    transition-duration: 0.25s, 1s;
    position: relative;
    padding: 0;
    left: 0;
    height: 600px;
    display: flex;
  }
  .swiper_wrap {
    width: 274px;
    float: left;
    text-align: center;
    /* margin: 0 50px; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .carousel_active {
    background: url("../../assets/aboutUs/item_bg.png") no-repeat;
    background-position: center;
    background-size: cover;
  }
}
.mySwiper .swiper-container {
  width: 90% !important;
}
.phonePage {
  height: 100vh !important;
}
</style>



// WEBPACK FOOTER //
// src/components/page/aboutUs.vue